import { Box } from '@mui/joy';
import { IconLogo } from '@/components/IconLogo';
import { AspectRatio } from '@mui/joy';
import { useStableImage } from '@/features/recipes/hooks/useStableImageUrls';
import { RECIPE_CARD_IMAGE_SIZES } from '@/features/recipes/hooks/useRecipeGridColumns';
import { useTheme, useMediaQuery } from '@mui/material';

export function RecipeImage({ recipe, orientation, size = 80, sx = {} }) {
  const image = useStableImage(recipe.images?.[0]);
  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.down('sm'));    
  const verticalRatio = isXs ? 6/4 : 8/4;
  const ratio = orientation == "horizontal" ? 1 : verticalRatio;

  return (    
    <AspectRatio ratio={ratio} sx={{ width: orientation == "horizontal" ? size : 'auto', ...sx }}>
      {
        (image?.url ?
          <img
            src={image.url}
            srcSet={image.srcset}
            sizes={orientation == "horizontal" ? `${size}px` : RECIPE_CARD_IMAGE_SIZES}
            alt={recipe.name}
            loading="lazy"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          /> :
          <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', opacity: 0.25, backgroundColor: '#fff' }}><IconLogo size={size < 80 ? "66%" : "33%"} /></Box>
        )
      }
    </AspectRatio>
  );
}
